export const wordsCount = (text) => {
    if (!text) return 0;

    return text.trim().length === 0 ? 0 : text.trim().split(/\s+/).length
}